import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function PolitiqueConfidentialite() {
  return (
    <div className="px-5 pb-24 pt-36 sm:px-8 lg:pt-44" data-testid="politique-confidentialite-page">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary">Protection des données</p>
          <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight sm:text-4xl">Politique de confidentialité</h1>
          <p className="mt-5 text-base leading-relaxed text-muted-foreground">Dernière mise à jour : août 2026</p>
          <div className="my-10 h-px bg-border" />
        </Reveal>

        <Reveal delay={0.08}>
          <div className="space-y-10 text-base leading-relaxed text-muted-foreground" data-testid="politique-confidentialite-content">

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">1. Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données personnelles collectées sur ce site est <strong className="text-foreground">Intellix SAS</strong>, dont le siège social est situé au 4 Rue Marie Bracquemont, 85660 Saint Philbert De Bouaine (SIRET : 941 084 386 00015).
              </p>
              <p className="mt-3">
                Contact : <a href="mailto:tcodet@intellix.fr" className="text-primary hover:text-foreground transition-colors">tcodet@intellix.fr</a> — <a href="tel:+33259604281" className="text-primary hover:text-foreground transition-colors">+33 2 59 60 42 81</a>
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">2. Données collectées</h2>
              <p>Nous collectons les données personnelles suivantes via le formulaire de contact :</p>
              <ul className="mt-4 space-y-2 pl-1">
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Nom complet</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Adresse e-mail</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Nom de l'entreprise (facultatif)</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Sujet de la demande (facultatif)</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Contenu du message</span></li>
              </ul>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">3. Finalités du traitement</h2>
              <p>Les données collectées sont utilisées exclusivement pour :</p>
              <ul className="mt-4 space-y-2 pl-1">
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Répondre à vos demandes de contact et d'information</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Assurer le suivi commercial de votre demande</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span>Améliorer la qualité de nos services</span></li>
              </ul>
              <p className="mt-4">
                Vos données ne sont jamais vendues, louées ou partagées avec des tiers à des fins commerciales.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">4. Base légale</h2>
              <p>
                Le traitement de vos données repose sur votre <strong className="text-foreground">consentement</strong> (article 6.1.a du RGPD), exprimé lors de l'envoi du formulaire de contact, ainsi que sur notre <strong className="text-foreground">intérêt légitime</strong> (article 6.1.f) à répondre aux demandes commerciales.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">5. Durée de conservation</h2>
              <p>
                Les données issues du formulaire de contact sont conservées pendant une durée maximale de <strong className="text-foreground">36 mois</strong> à compter de votre dernier échange avec Intellix, sauf obligation légale de conservation plus longue.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">6. Vos droits</h2>
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="mt-4 space-y-2 pl-1">
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span><strong className="text-foreground">Droit d'accès</strong> : obtenir la confirmation que vos données sont traitées et en recevoir une copie</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span><strong className="text-foreground">Droit de rectification</strong> : corriger des données inexactes ou incomplètes</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span><strong className="text-foreground">Droit à l'effacement</strong> : demander la suppression de vos données</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span><strong className="text-foreground">Droit à la portabilité</strong> : recevoir vos données dans un format structuré</span></li>
                <li className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /><span><strong className="text-foreground">Droit d'opposition</strong> : vous opposer au traitement de vos données</span></li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous par email : <a href="mailto:tcodet@intellix.fr" className="text-primary hover:text-foreground transition-colors">tcodet@intellix.fr</a>.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">7. Cookies</h2>
              <p>
                Ce site utilise des cookies strictement nécessaires au fonctionnement du service et à l'analyse anonyme de la fréquentation. Aucun cookie publicitaire ou de suivi à des fins commerciales n'est utilisé.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">8. Sécurité</h2>
              <p>
                Intellix met en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, perte, altération ou divulgation.
              </p>
            </section>

            <section>
              <h2 className="mb-4 font-display text-xl font-semibold text-foreground">9. Réclamation</h2>
              <p>
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la <strong className="text-foreground">Commission Nationale de l'Informatique et des Libertés (CNIL)</strong> — <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-primary hover:text-foreground transition-colors">www.cnil.fr</a>.
              </p>
            </section>

          </div>
        </Reveal>
      </div>
    </div>
  );
}
